import httpClient from '@/api/httpClient'

export class MapReportApi {
  static async searchForAdvertisers(keyword, advertiserId, pageNo, pageSize) {
    const res = await httpClient.post(`/map_report/${advertiserId}/search`, {
      keyword,
      pageNo: pageNo,
      pageSize: pageSize,
    })
    return res.data
  }

  static async remove(mapReportId) {
    const res = await httpClient.delete(`/map_report/${mapReportId}`)
    return res.data
  }

  static async create(form, advertiserId) {
    const res = await httpClient.post(`/map_report`, {
      name: form.name,
      advertiserId: advertiserId,
      insertionOrderId: form.insertionOrderId,
      accountId: form.accountId,
      extractionStartDate: form.extractionStartDate,
      extractionEndDate: form.extractionEndDate,
    })
    return res.data
  }

  static async updateName(mapReportId, name) {
    const res = await httpClient.put(`/map_report/${mapReportId}`, {
      name,
    })
    return res.data
  }

  static async findById(mapReportId, advertiserId) {
    try {
      const res = await httpClient.get(
        `/map_report/${mapReportId}?advertiser_id=${advertiserId}`,
      )
      return res.data
    } catch (e) {
      console.log('マップレポート取得に失敗しました', e)
    }
  }

  static async findByIdForAdmin(mapReportId) {
    const res = await httpClient.get(`/map_report/${mapReportId}`)
    return res.data
  }

  static async searchForAdmin(query, pageNo, pageSize) {
    const res = await httpClient.post(`/map_report/search`, {
      query,
      pageNo: pageNo,
      pageSize: pageSize,
    })
    return res.data
  }

  static async updateUrl(mapReportId, url) {
    const res = await httpClient.put(`/map_report/${mapReportId}/url`, {
      url,
    })
    return res.data
  }

  static async updateRejectStatus(mapReportId, rejectReason) {
    const res = await httpClient.put(`/map_report/${mapReportId}/reject`, {
      rejectReason,
    })
    return res.data
  }

  static async registerAutoGenerated(mapReportId, isAutoGenerated) {
    const res = await httpClient.put(
      `/map_report/${mapReportId}/auto_generated`,
      { isAutoGenerated },
    )
    return res.data
  }
}
